import { render, staticRenderFns } from "./ShareDetail.vue?vue&type=template&id=168d5e7c&"
import script from "./ShareDetail.vue?vue&type=script&lang=ts&"
export * from "./ShareDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports